import { useParams } from "react-router-dom";

import MapChart from "./MapChart";
import RegionSummary from "./RegionSummary";
import Tab from "../../common/Tab";
import BreadcrumbSearch from "../../common/BreadcrumbSearch";
import NotFound from "../../common/ErrorPage/NotFound";

const District = (props) => {
  let didParam = props.searchParam.district;
  let pidParam = props.searchParam.province;

  const { pid, did } = useParams();

  if (!pidParam) {
    pidParam = pid;
  }
  if (!didParam) {
    didParam = did;
  }

  const { tab, fetched, provinces, data, parties } = props;
  const province = provinces.find((p) => p.id === parseInt(pidParam));

  const district = province && province.districts.find((d) => d.id === didParam);

  if (!district) {
    return <NotFound />;
  }

  const provinceData = data.provinces.find((pData) => pData.id === province.id);
  const districtData = (provinceData && provinceData.districts.find((dData) => dData.id === district.id)) || { regions: [] };

  return (
    <>
      {/* <Tab tab={tab} handleTabChange={props.handleTabChange} /> */}
      <BreadcrumbSearch tab={tab} showSearch={true} searchParam={props.searchParam} provinces={provinces} handleSearch={props.handleSearch} />
      <MapChart tab={tab} fetched={fetched} pid={pidParam} provinceColor={province.color} district={district} parties={parties} data={districtData} />
      <RegionSummary tab={tab} fetched={fetched} pid={pidParam} district={district} parties={parties} data={districtData.regions} />
    </>
  );
};

export default District;
